import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// utils
import { stringAvatar } from "./utils";
import { isEmpty } from "../../utils";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#505050",
    color: "#fff",
    // color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 1px 1px grey",
    fontSize: 11,
  },
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 1px 1px grey",
    fontSize: 11,
  },
}));

// 這邊不要設定 width, height, 否則會蓋過 component sx 的設定
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  "&.MuiAvatar-root": {
    // width: "24px",
    // height: "24px",
    // fontSize: "12px",
  },
}));

//
const AvatarBasic = ({ tooltipProps, avatarProps }) => {
  // style
  const classes = useStyles();
  // props
  const { letter, sx, ...restAvatarProps } = avatarProps;
  // local state

  return (
    (!isEmpty(tooltipProps) && (
      <DarkTooltip title="Add" placement="right" {...tooltipProps}>
        <StyledAvatar
          {...stringAvatar(letter, sx)}
          {...(restAvatarProps || {})}
        />
      </DarkTooltip>
    )) || (
      <StyledAvatar
        {...stringAvatar(letter, sx)}
        {...(restAvatarProps || {})}
      />
    )
  );
};

AvatarBasic.propTypes = {
  tooltipProps: PropTypes.objectOf(PropTypes.any),
  avatarProps: PropTypes.objectOf(PropTypes.any),
};

AvatarBasic.defaultProps = {
  tooltipProps: {},
  avatarProps: {},
};

export default AvatarBasic;
